import * as React from 'react'

import { AccessibleProps, Props } from '../utils/types'
import { useEventListener } from '../effects/EventListener'

interface ClickOutsideProps extends AccessibleProps, Props {
  container?: any
  containerClass?: string
  onClickOutside?: (event: React.MouseEvent<Element, Event>) => any
}

export const ClickOutside = React.forwardRef<HTMLElement, ClickOutsideProps>(
  ({ children, container, containerClass, onClickOutside, ...props }, ref) => {
    const Component = container || 'div'

    const scope =
      (ref as React.RefObject<HTMLElement>) || React.useRef<HTMLElement>(null)

    // need useCallback?
    const handler: React.EventHandler<any> = event => {
      const current = scope.current as HTMLElement

      if (!current) {
        return
      }

      onClickOutside && !current.contains(event.target) && onClickOutside(event)
    }

    const options = { capture: true }

    useEventListener({ event: 'click', handler, options })

    useEventListener({ event: 'touchend', handler, options })

    return (
      <Component {...props} className={containerClass} ref={scope}>
        {children}
      </Component>
    )
  }
)

ClickOutside.displayName = 'ClickOutside'

export default ClickOutside
